import React from "react";
import { Box } from "@material-ui/core";
import { FTLButton } from "../FTLButton";
export const FTLToolbar = ({ currentTabIndex, length, disabled, children, position = "absolute", onSaveMessage = "Сохранить", onCancel, onSaveBtnId, async, goToNextTab = () => { }, goToPrevTab = () => { }, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { mt: 6, height: "56px", flexShrink: "0" }),
        React.createElement(Box, { display: "flex", justifyContent: "space-between", position: position, bottom: "0", width: "inherit", height: "56px", alignItems: "center", style: {
                background: "#fff",
                zIndex: 1,
                borderTop: "2px solid #E3E5E8",
                flexShrink: 0,
            } },
            React.createElement(Box, { display: "flex" },
                React.createElement(FTLButton, { form: onSaveBtnId, async: async, type: "submit", color: "primary", disabled: disabled, style: {
                        flexShrink: 0,
                    } }, onSaveMessage),
                onCancel && (React.createElement(Box, { ml: 2, mr: 2, flexShrink: 0 },
                    React.createElement(FTLButton, { variant: "text", onClick: () => onCancel && onCancel() }, "\u041E\u0442\u043C\u0435\u043D\u0430"))),
                children),
            typeof currentTabIndex === "number" && Boolean(length) && (React.createElement(Box, { display: "flex" },
                React.createElement(FTLButton, { color: "secondary", disabled: currentTabIndex === 0, onClick: goToPrevTab }, "\u041D\u0430\u0437\u0430\u0434"),
                React.createElement(Box, { ml: 2 },
                    React.createElement(FTLButton, { color: "secondary", disabled: currentTabIndex === length, onClick: goToNextTab }, "\u0414\u0430\u043B\u0435\u0435")))))));
};
//# sourceMappingURL=index.js.map